/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
import LeaderboardListItem from './LeaderboardListItem';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.leaderboard`;

export default class LeaderboardHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return (
			<div className="LeaderboardHero Hero">
				<h1 className="Hero-title">{t(`${prfx}.title`)}</h1>
				<div className="Hero-subtitle">
					{icon(LeaderboardListItem.getIconMap()[app.leaderboard.activityType])} {t(`${prfx}.nav.${app.leaderboard.activityType}`)}
				</div>
			</div>
		);
	}
}
